export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=707eb6da7c7845d209d25b750b59cdc144026f0940&name=pushAdClickData!'